import { SpinnerModalComponent } from './../spinner/spinner-modal.component';
import { SiteModel } from 'src/app/shared/models/societe-linked/site.model';
import { Ca1Model } from 'src/app/shared/models/societe-linked/ca1.model';
import { GestionReferentielComponentService } from './../../../../core/gestion-referentiel/gestion-referentiel-component.service';
import { SeuilService } from './../../../services/simple/seuil.service';
import { SeuilModel } from './../../../models/simple-types/seuil.model';
import { UntypedFormGroup } from '@angular/forms';
import { SiteService } from './../../../services/societe-linked/site.service';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { GestionCa1Component } from './../../../../core/gestion-referentiel/gestion-ca1/gestion-ca1.component';
import { ToastrService } from 'ngx-toastr';
import { Ca1Service } from './../../../services/societe-linked/ca1.service';
import { Router } from '@angular/router';
import { Component, OnInit, Inject } from '@angular/core';
import { Ca1ModelDTO } from 'src/app/shared/dtos/ca1ModelDTO';

export interface DialogData {
  form: UntypedFormGroup;
  ca1s: Ca1Model[];
  societeId: number;
  result: boolean;
}
@Component({
  selector: 'app-modal-add-ca1',
  templateUrl: './modal-add-ca1.component.html',
  styleUrls: ['./modal-add-ca1.component.scss']
})
export class ModalAddCa1Component implements OnInit {

  sites: SiteModel[];
  ca1s: Ca1Model[];
  form: UntypedFormGroup;
  seuilForm: UntypedFormGroup;
  site: SiteModel;
  seuil: SeuilModel = new SeuilModel();
  constructor(public dialog: MatDialog
            , public dialogRef: MatDialogRef<GestionCa1Component>
            , @Inject(MAT_DIALOG_DATA) public data: DialogData
            , private toastr: ToastrService
            , private router: Router
            , private ca1Service: Ca1Service
            , private siteService: SiteService
            , private seuilService: SeuilService
            , private gestionReferentielComponent: GestionReferentielComponentService) {

             }

  ngOnInit(): void {
    this.ca1s = this.data.ca1s;
    // Ajouter un SeuilModel + gestion des seuils
    this.form = this.data.form;
    if (!this.form.get('id').value){
      this.seuilForm = this.gestionReferentielComponent.getSeuilFormGroup(this.seuil);
    } else {
      this.seuilService.GetSeuilByCa1(this.data.form.get('code').value, this.data.societeId, 'BC').subscribe(seuil => {
        this.seuil = seuil;
        this.seuilForm = this.gestionReferentielComponent.getSeuilFormGroup(this.seuil);
      });
    }
      // Récuperation des sites
    this.siteService.getFromSociete(this.data.societeId).subscribe(sites => {
      this.sites = sites;
      this.site = sites.find(s => s.code === this.data.form.get('site').value);
    });
  }


  onModalCancel(): void {
    this.data.result = false;
    this.dialogRef.close(false);
  }

  onModalConfirm(): void {
    if (this.form.valid && this.seuilForm.valid) {
      const ca1 = this.form.getRawValue();
      this.site ? ca1.site = this.site.code : ca1.site = '';
      const seuil = this.seuilForm.getRawValue();
      seuil.codeCa1 = ca1.code;
      seuil.idSociete = ca1.idSociete;
      seuil.type = 'BC';
      const ca1DTO = new Ca1ModelDTO();
      ca1DTO.ca1 = ca1;
      ca1DTO.seuil = seuil;
      // Création
      if (!this.form.get('id').value){
        const dialogRef = this.dialog.open(SpinnerModalComponent);
          this.ca1Service.postCa1(ca1DTO).subscribe((a: Ca1Model) => {
            if (a) {
              this.toastr.success('', 'Création du ca1 ' + a.code + ' réussie');
            }
            this.dialogRef.close(true);
            dialogRef.close();
          }, (error) => {
            this.dialogRef.close(true);
            dialogRef.close();
          });
      }else { // Modification
        const dialogRef = this.dialog.open(SpinnerModalComponent);
        this.ca1Service.updateCa1(ca1DTO).subscribe((a: Ca1Model) => {
          if (a) {
            this.toastr.success('', 'Modification du ca1 ' + a.code + ' réussie');
          }
          this.dialogRef.close(true);
          dialogRef.close();
        }, (error) => {
          this.dialogRef.close(true);
          dialogRef.close();
        });
      }
    } else {
      this.displayErrors();
    }
  }

  displayErrors(): void {
    for (const index in this.form.controls) {
      if (index) {
        this.form.controls[index].markAsTouched();
      }
    }
    for (const index in this.seuilForm.controls) {
      if (index) {
        this.seuilForm.controls[index].markAsTouched();
      }
    }
  }
}

